import { useMemo } from 'react'
import { useAppSelector } from 'hooks/reduxHooks'
import { EmptyObject } from 'lib/object/objectUtils'
import { applyLeadChannelMarkupToSearchMetaData } from 'lib/channelMarkup/channelMarkupLeadPricing'
import { getChannelMarkupLeadOffer, getChannelMarkupSource } from 'selectors/channelMarkupSelector'
import useOfferListKey from './useOfferListKey'

function useOfferMetaData(offerId: string, filters: App.OfferListFilters = EmptyObject): App.OfferListMetaData | undefined {
  const offerMetaDataKey = useOfferListKey(filters)

  const metaData = useAppSelector(state => state.offer.searchResultMetadata.offerMetaData[offerMetaDataKey]?.[offerId])
  const offer = useAppSelector(state => getChannelMarkupLeadOffer(state, offerId))
  const markupSource = useAppSelector(getChannelMarkupSource)

  // Flash/LPC search prices are stored before channel markup and marked here, on the offer's lead
  // price, so a tile's search price matches the offer page and checkout. The lookup already covers
  // bedbank offers, whose search prices are deferred the same way in the next PR of the stack.
  return useMemo(
    () => metaData && applyLeadChannelMarkupToSearchMetaData(metaData, offer, markupSource),
    [metaData, offer, markupSource],
  )
}

export default useOfferMetaData
